import {observer} from 'mobx-react';
import {RadioButton, RadioButtonGroup, Select2, NumberInput, FormError} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const RECURRING_DEFAULTS = {value: 1, unit: 'months'};
const NEVER = {value: null, unit: null};

const ReassignmentIntervalSelector = observer(({value, unit, onChange, errorMessage}) => {
  const selectedOption = unit ? 'recurring' : 'never';
  const toggle = option => onChange(option === 'recurring' ? RECURRING_DEFAULTS : NEVER);
  const change = changes => onChange({value, unit, ...changes});

  return (
    <div>
      <RadioButtonGroup
        label='components.reassignment_interval_selector.Reassign After Completion'
        name='reassignAfterCompletion'
        selectedValue={selectedOption}
        onChange={(_, option) => toggle(option)}
      >
        <RadioButton className='block my1' value='never'>
          <FormattedMessage id='components.reassignment_interval_selector.Never'/>
        </RadioButton>
        <div className='my1'>
          <RadioButton className='table-cell align-middle pr1' value='recurring'></RadioButton>
          <div className='table-cell align-middle full-width'>
            <div className='clearfix table mxn1'>
              <div className='col-1 table-cell align-middle pr1'>
                <FormattedMessage id='components.reassignment_interval_selector.Every'/>
              </div>
              <div className='col-2 table-cell align-middle px1'>
                <NumberInput
                  disabled={selectedOption === 'never'}
                  value={value || ''}
                  onChange={e => change({value: e.target.value})}
                />
              </div>
              <div className='col-3 table-cell align-middle px1'>
                <Select2
                  disabled={selectedOption === 'never'}
                  dropDownClass='select2-animation'
                  value={unit || ''}
                  onChange={e => change({unit: e.target.value})}
                >
                  <option key='months' value='months'>{t('months')}</option>
                  <option key='years' value='years'>{t('years')}</option>
                </Select2>
              </div>
              <div className='col-6 table-cell align-middle px1'>
                <span className='tuatara'>
                  <FormattedMessage id='components.reassignment_interval_selector.after each completion'/>
                </span>
              </div>
            </div>
          </div>
        </div>
      </RadioButtonGroup>
      <FormError message={errorMessage}/>
    </div>
  );
});

export default ReassignmentIntervalSelector;
